import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import { compose } from 'react-apollo';

import NotAuthenticated from 'components/NotAuthenticated';
import withAuth from './withAuth';

export default WrappedComponent => {
  return compose(
    withAuth,
    branch(({ isLoggedIn }) => {
      return !isLoggedIn;
    }, renderComponent(NotAuthenticated))
  )(WrappedComponent);
};



// WEBPACK FOOTER //
// ./src/common/hoc/renderIfNotAuthenticated.js